import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100% - 40px);
  overflow-y: none;
`

export const ProfileIdeaInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  margin-left: 250px;
  margin-bottom: 48px;
`

export const ProfileIdealGraphWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 350px;
  height: 220px;
  gap: 20px;
  p {
    margin: 0;
    margin-top: -20px;
    font-size: 14px;
  }
  span {
    font-size: 12px;
    margin-top: 10px;
    font-weight: 700;
  }
`

export const WrapperInfoCompetences = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
  justify-content: space-between;
`

export const SkillsIdealProfileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
  margin-left: 250px;
  margin-bottom: 20px;
`

export const BoldText = styled.span`
  font-weight: 700;
`

export const BetesaBoldText = styled(BoldText)`
  margin-top: 30px;
`

export const BetesaEditText = styled.span<{ valid: boolean }>`
  margin: 30px 0 0 380px;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: ${({ valid }) => (valid ? '#2D749C' : '#C2C2C2')};
  cursor: pointer;
  z-index: 1;

  // hover
  &:hover {
    opacity: 0.8;
    text-decoration: underline;
  }
`

export const AlertLevelText = styled.span`
  font-weight: 700;
  margin-top: -36px;
  margin-left: 110px;
`

export const List = styled.ol`
  width: 100%;
  padding: 0;
  margin: 0;
  padding-left: 20px;
`

export const ListItem = styled.li`
  width: 100%;
  padding-bottom: 8px;
  font-size: 14px;
  font-weight: 400;
`

export const DateWrapper = styled.div`
  display: flex;
  width: 20%;

  @media (max-width: 1700px) {
    width: 25%;
  }
  @media (max-width: 1400px) {
    width: 30%;
  }
  @media (max-width: 1250px) {
    width: 40%;
  }
  @media (max-width: 1100px) {
    width: 50%;
  }
`

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 40px;
`

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  width: 90%;
  margin-bottom: 24px;
  gap: 20px;
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin: 30px 0 0 0;
`

export const TrashIconBig = styled.img`
  width: 70px;
  height: 70px;
`

export const TrashIconWhite = styled.img`
  width: 20px;
  height: 25px;
`
